import { jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
import SVG from "./outline/stock-split.svg";
var StockSplitOutline_default = forwardRef(
  (props, ref) => /* @__PURE__ */ jsx(SVG, { ref, ...props })
);
export {
  StockSplitOutline_default as default
};
